import React, { useEffect, useState } from "react";
import stellantis from "../assets/images/Stellantis.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faArrowLeft,
  faCaretDown,
  faMaximize,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

import { generateLink } from "../services/GenerateLink";
import { generateAppLink } from "../services/GenerateAppLink";
import { useNavigate } from "react-router-dom";
import OldData from "./OldData"; // OldData bileşenini doğru yoldan içe aktarın



const Dashboard = () => {
  const navigate = useNavigate();

  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [generatedLink, setGeneratedLink] = useState("");
  const [userData, setUserData] = useState(null);
  const [selectedReport, setSelectedReport] = useState(null);
  const [selectedApp, setSelectedApp] = useState(null);
  const [muvafakatLink, setMuvafakatLink] = useState(null);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    const storedUserData =
      JSON.parse(localStorage.getItem("userData")) ||
      JSON.parse(sessionStorage.getItem("userData"));

    if (!storedUserData || storedUserData.STATUS !== 200) {
      navigate("/");
    } else {
      // Proje sıralama dizisi
      const projectOrder = [
        'Gizli Müşteri Satış Ziyaret',
        'Gizli Müşteri Satış Telefon',
        'Gizli Müşteri Servis Ziyaret',
        'Satış Denetim',
        'Servis Denetim',
        'Reddedenler Araştırması',
        'LCV - Satış Deneyim ve Beklenti Araştırması',
        'LCV - Servis Deneyim ve Beklenti Araştırması',
        'ERCS'
      ];

      // Kullanıcı projelerini özel sıralamaya göre düzenleme
      const sortedProjects = storedUserData.userProjects.sort((a, b) => {
        const indexA = projectOrder.indexOf(a.PROJECT_DESC);
        const indexB = projectOrder.indexOf(b.PROJECT_DESC);

        // Eğer proje sıralama listesinde yoksa, sona at
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;

        // Sıralama indekslerine göre karşılaştır
        return indexA - indexB;
      });

      // Sıralanmış projeleri güncelle
      const updatedUserData = {
        ...storedUserData,
        userProjects: sortedProjects
      };

      setUserData(updatedUserData);
      console.log("USER DATAAAAAA");
      console.log(storedUserData);

      // Muvafakatname link bulma kısmı (önceki koddan aynı)
      const muvafakatModule = sortedProjects.flatMap(project =>
        project.projectModules || []
      ).find(module => module.APP_ID.includes('MUVAFAKATNAME'));

      if (muvafakatModule) {
        const link = generateAppLink(muvafakatModule.APP_ID, muvafakatModule.BRM_ID);
        setMuvafakatLink(link);
      }
    }
  }, [navigate]);

  const handleGenerateLink = (report, project) => {
    if (!userData) return;
    const link = generateLink(
      report.REPORT_TYPE,
      report.REPORT_ID,
      userData.SCRTKN,
      project.BRM_ID,
      project.T_HY_FILTER
    );
    setSelectedReport(report.REPORT_ID);
    setSelectedApp(null)
    setGeneratedLink(link);
    console.log(link);
  };

  const handleGenerateAppLink = (report, project) => {
    if (!userData) return;
    const link = generateAppLink(report.APP_ID, project.BRM_ID);
    setSelectedApp(report.APP_ID);
    setSelectedReport(null);
    setGeneratedLink(link);
    console.log(link);
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  };

  return (
    <div className="d-flex" style={{ height: "100vh" }}>
      {/* left Menu */}
      <div
        className={`bg-light border-end ${isMenuOpen ? "d-block" : "d-none"}`}
        style={{
          width: "250px",
          padding: "20px",
          backgroundColor: "#2c3e50",
          color: "white",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
<h5 className="text-center fw-bold mb-4" style={{ color: "#243782" }}>
            <img
              src={stellantis}
              style={{
                maxWidth: "160px",
                height: "auto",
                marginBottom: "10px",
              }}
              alt="Stellantis"
            />
</h5>


        {/* Sistem Kullanım Kılavuzu Bağlantısı */}
        <ul className="list-group">
          <li
            className="list-group-item border-0 mb-3"
            style={{
              backgroundColor: "#243782", // Arka plan rengi
              borderRadius: "5px", // Kenarları yuvarlatma
            }}
          >
            <a
              href="/docs/stellantis_sistem_kullanim_kilavuzu.pdf" // PDF dosyasının yolu
              target="_blank" // Yeni bir sekmede açmak için
              rel="noopener noreferrer" // Güvenlik için
              className="text-decoration-none"
              style={{
                fontSize: "0.9rem",
                color: "white", // Metin rengi
                display: "flex", // İkon ve metni hizalamak için
                alignItems: "center", // Dikey hizalama
                padding: "10px", // İçerik boşluğu
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#808080")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
            >
              {/* Soru İşareti İkonu */}
              <FontAwesomeIcon
                icon={faInfoCircle} // FontAwesome soru işareti ikonu
                className="me-2" // Sağ boşluk
                style={{
                  color: "white", // İkon rengi
                }}
              />
              {/* Kalın Sistem Kullanım Kılavuzu Metni */}
              <span style={{ fontWeight: "bold" }}>Sistem Kullanım Kılavuzu</span>
            </a>
          </li>
        </ul>


        {/* Projeler */}
        <ul className="list-group">
          {userData &&
            userData.userProjects.map((project, index) => (
              <li
                key={index}
                className="list-group-item border-0"
                style={{ backgroundColor: "#243782", marginBottom: "10px" }}
              >
                {/* Ana başlık (Projeler) */}
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-light">{project.PROJECT_DESC}</span>
                  <button
                    data-bs-toggle="collapse"
                    data-bs-target={`#dropdown-${index}`}
                    aria-expanded="false"
                    aria-controls={`dropdown-${index}`}
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      padding: 0,
                      cursor: "pointer",
                    }}
                  >
                    <FontAwesomeIcon icon={faCaretDown} style={{ color: "white" }} />
                  </button>
                </div>

                {/* Alt başlıklar (Raporlar ve İtiraz Formu) */}
                <div className="collapse mb-4" id={`dropdown-${index}`}>
                  <ul className="list-unstyled mt-2">
                    {/* Raporlar */}
                    <li>
                      <span className="text-light">Raporlar</span>
                      <ul className="list-unstyled ms-3">
                        {project?.projectReports?.map((report, idx) => (
                          <li
                            key={idx}
                            className="mb-2"
                            style={{
                              borderRadius: 5,
                              backgroundColor:
                                selectedReport === report.REPORT_ID
                                  ? "#ecf0f1"
                                  : "#243782",
                            }}
                          >
                            <a
                              href="#"
                              onClick={() => handleGenerateLink(report, project)}
                              className="text-decoration-none"
                              style={{
                                fontSize: "0.9rem",
                                color:
                                  selectedReport === report.REPORT_ID
                                    ? "#243782"
                                    : "white",
                              }}
                              onMouseEnter={(e) => (e.target.style.color = "#808080")}
                              onMouseLeave={(e) =>
                              (e.target.style.color =
                                selectedReport === report.REPORT_ID
                                  ? "#243782"
                                  : "white")
                              }
                            >
                              - {report.REPORT_DESCRIPTION}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </li>

                    {/* İtiraz Formu */}
                    {project?.projectModules?.some(
                      (module) => module.APP_DESCRIPTION === "İtiraz Formu"
                    ) && (
                        <li>
                          <a
                            href="#"
                            onClick={() =>
                              project.projectModules
                                .filter((module) => module.APP_DESCRIPTION === "İtiraz Formu")
                                .forEach((module) =>
                                  handleGenerateAppLink(module, project)
                                )
                            }
                            className="text-decoration-none"
                            style={{
                              fontSize: "0.9rem",
                              color: "white",
                            }}
                            onMouseEnter={(e) => (e.target.style.color = "#808080")}
                            onMouseLeave={(e) => (e.target.style.color = "white")}
                          >
                            İtiraz Formu
                          </a>
                        </li>
                      )}
                  </ul>
                </div>
              </li>
            ))}
{/* Geçmiş Veriler Başlığı */}
{(userData?.USER_ID === 'STE001' || userData?.USER_ID === 'STE002' || userData?.USER_ID === 'STE003' || userData?.USER_ID === 'STE004') && (
  <li
    className="list-group-item border-0"
    style={{ backgroundColor: "#243782", marginBottom: "10px" }}
  >
    <a
      href="#"
      onClick={() => setGeneratedLink("gecmis-veriler")}
      className="text-decoration-none"
      style={{
        fontSize: "0.9rem",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
      onMouseEnter={(e) => (e.target.style.color = "#808080")}
      onMouseLeave={(e) => (e.target.style.color = "white")}
    >
      <span>Geçmiş Veriler</span>
    </a>
  </li>
)}


        </ul>
      </div>



      <div className="flex-grow-1">
        {/* Navbar */}
        <nav
          className="navbar navbar-expand-lg navbar-dark shadow-sm"
          style={{ background: "linear-gradient(to left, #2c3e50, #243782)" }}
        >
          <div className="container-fluid">
            <a
              className="navbar-brand fw-bold"
              href="#"
              onClick={toggleMenu}
              style={{ cursor: "pointer", color: "white" }}
            >
              <FontAwesomeIcon icon={isMenuOpen ? faArrowLeft : faArrowRight} className="me-3" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto">
                {/* Kullanıcı Email */}
                <li className="nav-item">
                  <a className="nav-link" style={{ color: "#ecf0f1" }}>
                    {userData ? userData.EMAIL : ""}
                  </a>
                </li>

                {/* İşlemler Menüsü */}
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ color: "#ecf0f1" }}
                  >
                    İşlemler
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                    <li>
                      <a
                        className="dropdown-item"
                        href="/docs/stellantis_sistem_kullanim_kilavuzu.pdf" // PDF dosyasının yolu
                        target="_blank" // Yeni bir sekmede açmak için
                        rel="noopener noreferrer" // Güvenlik için
                        style={{ fontSize: "0.9rem" }}
                      >
                        Sistem Kullanım Kılavuzu
                      </a>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={handleLogout}
                        style={{ fontSize: "0.9rem" }}
                      >
                        Çıkış Yap
                      </a>
                    </li>
                  </ul>
                </li>

              </ul>
            </div>
          </div>
        </nav>


        <div
          className="p-3 m-3 shadow"
          style={{ backgroundColor: "black", height: "100%" }}
        >
          {generatedLink === "gecmis-veriler" ? (
            <OldData />
          ) : generatedLink ? (
            <iframe
              src={generatedLink}
              style={{
                width: "100%",
                height: "100vh",
                border: "none",
                overflow: "hidden",
                transform: "scale(0.98)",
              }}
              title="Generated Report"
            ></iframe>
          ) : (
            <p style={{ color: "white" }}>Hoş Geldiniz.</p>
          )}
        </div>

      </div>
    </div>
  );
};

export default Dashboard;